// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._0XBhYtaYaARrHw-XbTCWbw\\=\\= .changed-address{font-weight:bold}._0XBhYtaYaARrHw-XbTCWbw\\=\\= .alert{align-items:center}", "",{"version":3,"sources":["/app/client_react/src/components/PersonalSettings/Components/USPSAddressVerificationModal/USPSAddressVerificationModal.styl"],"names":[],"mappings":"AAGE,8CACE,gBAAa,CAGf,oCACE,kBAAa","file":"USPSAddressVerificationModal.styl","sourcesContent":["@import '../../../../../../client/styles/vars';\n\n:local(.global) {\n  .changed-address {\n    font-weight: bold;\n  }\n\n  .alert {\n    align-items: center;\n  }\n}\n"]}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"global": "_0XBhYtaYaARrHw-XbTCWbw=="
};
module.exports = ___CSS_LOADER_EXPORT___;
